export const HELP_DESK_FEEDBACK = 'V2/HELP_DESK_FEEDBACK'
export const HELP_DESK_FEEDBACK_QUESTIONS = 'V2/HELP_DESK_FEEDBACK_QUESTIONS'
export const SET_FEEDBACK_CURRENT_ITEM = 'set current feedback'



export function setHelpDeskFeedback(payload) {
    return {
        type: HELP_DESK_FEEDBACK,
        payload: payload
    }
}

export function setHelpDeskFeedbackQuestions(payload) {
    return {
        type: HELP_DESK_FEEDBACK_QUESTIONS,
        payload: payload
    }
}

export function setFeedbackCurrentItem(payload) {
    return {
        type: SET_FEEDBACK_CURRENT_ITEM,
        payload: payload
    }
}



// WEBPACK FOOTER //
// ./src/model/Feedback/actions.js